import {makeObservable} from 'mobx';

import type {ID, Nullable} from '../../../utils/utility-types';
import type {AppEventModel} from '../AppEvent/AppEvent.model';

import {BaseModel} from '../Base/Base.model';

const ModelName = 'WsMessageModel';

export class WsMessageModel extends BaseModel {
  actor: Nullable<WsMessageModel.Actor>;
  channelId: ID;
  conference: Nullable<WsMessageModel.Conference>;
  courseId: ID;
  file: Nullable<WsMessageModel.File>;
  postId: ID;
  type: WsMessageModel.SupportedType;

  constructor(props: WsMessageModel.Props) {
    super(props);
    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<WsMessageModel, WsMessageModel.Props>(
        props,
      ),
    );
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace WsMessageModel {
  export type Actor = {
    id: string;
    name: string;
  };

  export type Conference = {
    id: string;
    type: 'chat' | 'live';
  };

  export type File = {
    id: string;
    userId: string;
  };

  export type Props = BaseModel.ModelToProps<WsMessageModel>;

  export type SupportedType =
    | 'coach_coverage_course_started'
    | 'coach_coverage_course_stopped'
    | 'file_converted'
    | 'membership_frozen'
    | 'membership_unfrozen'
    | 'post_created'
    | 'post_deleted'
    | 'post_updated'
    | AppEventModel.SupportedType;
}
